import type { PDSArticle, PDSPrice, PromotionPrice, Warranties } from '@expert/types';
import type { ProxyErrorMethod } from '~~/models/Error';
import type { State } from '../ExpArticle/exp_ArticleState';

export interface CtaButtonState {
    storeState: State;
    onlineState: State;
    redirectState: State;
    [stateKey: string]: State;
}

export enum CtaButtonType {
    DEFAULT = 'DEFAULT',
    ONLINE = 'ONLINE',
    STORE = 'STORE',
    REDIRECT = 'REDIRECT',
    CATEGORY_ONLINE = 'CATEGORY_ONLINE',
}

export type CtaButtonCallback = (event: CtaButtonActionEvent) => void;

export interface CtaButtonConfig {
    buttonType: CtaButtonType;
    callback: CtaButtonCallback;
    ctaStates: CtaButtonState;
}

export interface CtaButtonActionEvent {
    action: string;
    event: Event;
    errorProxyFunction: ProxyErrorMethod;
}

export interface OrderModalConfiguration {
    showModal: boolean;
    article: PDSArticle;
    price: PDSPrice;
    errorProxy: ProxyErrorMethod;
}
